/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassDeletePendingEnrollmentRequest
 */
export interface ClassDeletePendingEnrollmentRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassDeletePendingEnrollmentRequest
     */
    pendingUserIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClassDeletePendingEnrollmentRequest
     */
    classId: string;
}

/**
 * Check if a given object implements the ClassDeletePendingEnrollmentRequest interface.
 */
export function instanceOfClassDeletePendingEnrollmentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pendingUserIds" in value;
    isInstance = isInstance && "classId" in value;

    return isInstance;
}

export function ClassDeletePendingEnrollmentRequestFromJSON(json: any): ClassDeletePendingEnrollmentRequest {
    return ClassDeletePendingEnrollmentRequestFromJSONTyped(json, false);
}

export function ClassDeletePendingEnrollmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassDeletePendingEnrollmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pendingUserIds': json['pendingUserIds'],
        'classId': json['classId'],
    };
}

export function ClassDeletePendingEnrollmentRequestToJSON(value?: ClassDeletePendingEnrollmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pendingUserIds': value.pendingUserIds,
        'classId': value.classId,
    };
}

